/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Transcript_Export_Close_LabelInputs */



/**
* | output |
* | --- |
* | "Close Export Dialog" |
*
* @param {Transcript_Export_Close_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const transcript_export_close_label = /** @type {((inputs?: Transcript_Export_Close_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Transcript_Export_Close_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Fermer la boite de dialogue d'exportation")
	if (locale === "de") return /** @type {LocalizedString} */ ("Exportdialog schließen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Chiudi finestra di dialogo Esporta")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Закрыть диалоговое окно экспорта")
	if (locale === "es") return /** @type {LocalizedString} */ ("Cerrar el cuadro de diálogo de exportación")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("关闭导出对话框")
	if (locale === "ja") return /** @type {LocalizedString} */ ("エクスポートダイアログを閉じる")
	if (locale === "hi") return /** @type {LocalizedString} */ ("निर्यात संवाद बंद करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Fechar caixa de diálogo de exportação")
	return /** @type {LocalizedString} */ ("Close Export Dialog")
});